module.exports = __webpack_public_path__ + "static/image/sign/kimbongjin@3x.png?acd52fde";